import React, { useState, useEffect } from "react";
import testimonial from "../constants/testimonial";
// import MidDivider from './svg/FooterSeparator';
import hospital from "../assets/hospitals 1.png";
import { MidDivider } from "./svg/MidDivider";

const WhyUsPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDestop, setIsDesktop] = useState(false);

  // useEffect(() => {
  //   function handleResize() {
  //     if (window.innerWidth < 767) {
  //       setIsMobile(true);
  //     } else {
  //       setIsMobile(false);
  //     }

  //     if (window.innerWidth > 767) {
  //       setIsDesktop(true);
  //     } else {
  //       setIsDesktop(false);
  //     }
  //   }
  //   window.addEventListener("resize", handleResize);
  //   handleResize();
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);

  return (
    <div className="bg-[#FFFBFB] md:mb-8 h-[30%]">
      <div className="bg-[#B70303] pb-12">
        <MidDivider />
        <div className="mx-auto text-center sm:text-left  xl:px-[120px] md:px-[30px] sm:px-[30px] text-black">
          <p
            className="lg:text-[35px]  text-2xl font-lato font-extrabold leading-13 py-5 text-center text-white px-6 mt-5 mb-[25px]"
            style={{ wordSpacing: "0.25rem" }}
          >
            <span className="underline">2000+ hospitals</span> trust us to get
            them safer medical supplies, quicker.
          </p>
          <div className="flex pb-10 justify-center items-center">
            {isDestop ? (
              <div className="w-1/12">{""}</div>
            ) : (
              <div className="w-1/12">{""}</div>
            )}
            <div className="lg:w-full lg:flex lg:justify-center lg:items-center mb-10 w-full pt-10 mr-12 ">
              <img
                src={hospital}
                alt=""
                className="w-full max-w-full h-auto lg:w-[1200px] md:w-[1000px] sm:w-[800px]"
              />
            </div>
          </div>
          <div className="bg-white w-full mx-auto divide-y divide-gray-300 lg:flex lg:flex-row rounded mt-24 lg:mt-0">
            {testimonial.map((ele) => (
              <div className="px-8 py-8 justify-center" key={ele.id}>
                <div className="flex flex-col justify-center align-items">
                  {ele.id === 0 ? (
                    <div className="flex justify-center lg:justify-start">
                      <img
                        src={ele.image}
                        alt=""
                        className="h-auto sm:w-[200px] md:w-[100px] lg:w-[200px] mt-[-80px]"
                      />
                    </div>
                  ) : (
                    <div className="flex justify-center lg:justify-start lg:mt-0">
                      <img
                        src={ele.image}
                        alt=""
                        className="h-auto sm:w-[200px] md:w-[80px] lg:w-[200px] lg:mt-[-80px]"
                      />
                    </div>
                  )}

                  <p className="mt-12 lg:text-[20px] text-[15px] lg:text-justify text-center xl:max-h-[5%] xl:min-h-[5%]  md:max-h-[5%] md:min-h-[10%]  sm:max-h-[5%] sm:min-h-[5%]">
                    {ele.testimonial}
                  </p>
                  <div className="flex flex-col lg:justify-start lg:items-start justify-center items-center">
                    <p className="font-bold mt-8 mr-2">{ele.name}</p>
                    <p className="text-[#B70303] ">{ele.placeOfWork}</p>
                  </div>
                </div>
                <div className="h-4/6 w-1/2 absolute top-1/2 right-0 transform -translate-y-1/2 border-r"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUsPage;
